export { default } from './useScrollTrigger';


//////////////////
// WEBPACK FOOTER
// ./node_modules/@material-ui/core/esm/useScrollTrigger/index.js
// module id = 369
// module chunks = 0